import * as React from 'react';
import { FeedItemDto } from 'models/ApiModels';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiWidgetTitle from 'components/MuiExtras/MuiWidgetTitle';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import { TextPluralization } from "components/TextPluralization";
import { PublicationType } from 'models/ApiEnums';
import { useTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: FeedItemDto;
}

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const WidgetStatResume: React.FC<IProps> = (props) => {
    const { t } = useTranslation(["sys", "clientApp"]);
    const { data: { publicationType, statistics } } = props;

    const titlePrefix = "clientApp:Views.Publication.Widgets.WidgetStatResume.";

    let title = t(titlePrefix + "BoxTitleF") + " " + t("clientApp:Common.Literals.PublicationText");
    switch (publicationType) {
        case PublicationType.Post: title = t(titlePrefix + "BoxTitleF") + " " + t("sys:PublicationType.Post"); break;
        case PublicationType.Question: title = t(titlePrefix + "BoxTitleF") + " " + t("sys:PublicationType.Question"); break;
        case PublicationType.Poll: title = t(titlePrefix + "BoxTitleF") + " " + t("sys:PublicationType.Poll"); break;
        case PublicationType.Course: title = t(titlePrefix + "BoxTitleM") + " " + t("sys:PublicationType.Course"); break;
    }

    return (
        <MuiContainer margin="dense">
            <MuiWidgetTitle title={title} />

            <MuiColor variant="muted">
                <table>
                    <tbody>
                        <tr>
                            <td align="right"><span>{statistics.views}</span></td>
                            <td><span><TextPluralization count={statistics.views} resource="Views.Publication.Widgets.WidgetStatResume.ViewCount" /></span></td>
                        </tr>

                        {
                            publicationType == PublicationType.Question &&
                            <tr>
                                <td align="right"><span>{statistics.followers}</span></td>
                                <td><span>{t("clientApp:Views.Publication.Widgets.WidgetStatResume.FollowingText")}</span></td>
                            </tr>
                        }
                    </tbody>
                </table>
            </MuiColor>
        </MuiContainer>
    );
};

export default WidgetStatResume;